window.phoneOutOfStock = [

  /* =========================================================
     APPLE
     ========================================================= */

  // Add Apple models here.


  /* =========================================================
     SAMSUNG
     ========================================================= */

  // Add Samsung models here.


  /* =========================================================
     ONEPLUS
     ========================================================= */

  // Add OnePlus models here.


  /* =========================================================
     XIAOMI
     ========================================================= */

  // Add Xiaomi / Redmi models here.


  /* =========================================================
     MOTOROLA
     ========================================================= */

  // Add Motorola models here.
"motorola-edge-70-fusion",
"motorola-signature",

  /* =========================================================
     NOTHING
     ========================================================= */

  // Add Nothing models here.


  /* =========================================================
     GOOGLE PIXEL
     ========================================================= */

  // Add Google Pixel models here.


  /* =========================================================
     REALME
     ========================================================= */

  // Add Realme models here.


  /* =========================================================
     VIVO
     ========================================================= */

  // Add Vivo models here.
"vivo-s2-5g",

  /* =========================================================
     OPPO
     ========================================================= */

  // Add Oppo models here.


  /* =========================================================
     POCO
     ========================================================= */

  // Add Poco models here.


  /* =========================================================
     IQOO
     ========================================================= */

  // Add iQOO models here.
"iqoo-15r",

  /* =========================================================
     ASUS
     ========================================================= */

  // Add Asus models here.


  /* =========================================================
     SONY
     ========================================================= */

  // Add Sony models here.


  /* =========================================================
     HONOR
     ========================================================= */

  // Add Honor models here.


  /* =========================================================
     NOKIA
     ========================================================= */

  // Add Nokia models here.


  /* =========================================================
     INFINIX
     ========================================================= */

  // Add Infinix models here.


  /* =========================================================
     TECNO
     ========================================================= */

  // Add Tecno models here.


  /* =========================================================
     LAVA
     ========================================================= */

  // Add Lava models here.


  /* =========================================================
     HTC
     ========================================================= */

  // Add HTC models here.


  /* =========================================================
     MICROSOFT
     ========================================================= */

  // Add Microsoft models here.


  /* =========================================================
     OTHERS
     ========================================================= */

  // Add models from any other brand here.

];